
import { useContext, useEffect, useRef, useState } from 'react';
import FormButton from '../dashboardComponents/FormButton'
import FormInfoCard from '../dashboardComponents/FormInfoCard'
import { AppContext } from '../../../contextApi/ContextApi';
import { DashboardContext } from '../../../contextApi/DashboardContext';

export default function SetPersonalInfoForm({website}) {
  const {setToastMessage, messagesOptions, setCurrentManager} = useContext(AppContext);
  const {handleChangePersonalInfo} = useContext(DashboardContext);
  const [editFlag, setEditFlag] = useState(false);
  const [saveFlag, setSaveFlag] = useState(false);
  const [personalName, setPersonalName] = useState(website?.owner?.name);
  const [personalEmail, setPersonalEmail] = useState(website?.owner?.email);
  const [personalPhone, setPersonalPhone] = useState(website?.owner?.phone);
  const firstRender = useRef(true);
  useEffect(()=>{
    if(!editFlag){
      if(firstRender.current){
        firstRender.current = false;
        return;
      }
      const newData = {
        name:personalName,
        email:personalEmail,
        phone:personalPhone,
      }
      const func = async()=>{
        await handleChangePersonalInfo(website, newData, setSaveFlag, setEditFlag, setCurrentManager, setToastMessage, messagesOptions);
      }
      func();
    }
  },[editFlag])

  return (
    <div>
        <FormInfoCard editFlag={editFlag} setInfo={setPersonalName} label={"שם משתמש:"} val={personalName}/>
        <FormInfoCard editFlag={editFlag} setInfo={setPersonalEmail} label={"אימייל:"} val={personalEmail}/>
        <FormInfoCard editFlag={editFlag} setInfo={setPersonalPhone} label={"מס' פלאפון:"} val={personalPhone}/>
        <FormButton disabled={saveFlag} website={website} type={"button"} text={editFlag ? "שמור" : "ערוך"} action={()=>{setEditFlag(!editFlag)}}/>
    </div>
  )
}
